interface Props {
  label: string;
  value: string | number;
  sub: string;
  colorClass: string;
}
export function MetricCard({
  label,
  value,
  sub,
  colorClass
}: Props) {
  return <div className="mc" data-id="element-294">
      <div className="ml" data-id="element-295">{label}</div>
      <div className={`mv ${colorClass}`} data-id="element-296">{value}</div>
      <div className="ms" data-id="element-297">{sub}</div>
    </div>;
}